import React, { useEffect } from "react";
import { BASE_URL } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
  Grid,
  Paper,
  TextField,
  Autocomplete,
  Toolbar,
  Button,
} from "@mui/material";
import { useSnackbar } from "notistack";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";

export default function CreateCourier() {
  const [srfObject, createSrfObject] = React.useState({});
  const [executing, setExecuting] = React.useState(false);
  const [client, setClient] = React.useState([]);

  var refresh = () => {
    window.location.reload(false);
  };

  const onSubmit = (event) => {
    setExecuting(true);

    let row = {
      date: moment(srfObject.date).format("YYYY-MM-DD"),
      workOrderNumber: srfObject.workOrderNumber,
      clientID: srfObject.clientId,
      place: srfObject.place,
      courierPartner: srfObject.courierPartner,
      discription: srfObject.discription,
      purpose: srfObject.purpose,
      trackingNo: srfObject.trackingNo,
    };
    let url = BASE_URL;
    axiosWithToken
      .post(url + "clientCourier", row)
      .then((res) => {
        toast("Client Courier created successfully !");
        setTimeout(refresh, 500);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
      });
  };

  // data operations
  const updateSrfObject = (key, value) => {
    let newSrfObject = {
      ...srfObject,
    };
    newSrfObject[key] = value;
    createSrfObject(newSrfObject);
  };

  const getClient = (event) => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "clients?_where=(status,eq,1)")
      .then((res) => {
        setClient(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const clients = [];
  for (let i = 0; i < client.length; i++) {
    clients.push({
      label: client[i].id + ", " + client[i].companyName,
    });
  }

  useEffect(() => {
    getClient();
  }, []);

  return (
    <Paper sx={{ mt: 2, p: 2 }}>
      <Grid container spacing={2}>
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
            slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Date *"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              InputLabelProps={{ shrink: true }}
              value={srfObject.date ? new Date(srfObject.date) : ""}
              onChange={(newValue) => {
                // updateQuoObject("date", newValue);
                updateSrfObject("date", newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="Work Order Number"
            size="small"
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("workOrderNumber", e.target.value);
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={clients}
            renderInput={(params) => (
              <TextField {...params} label="Client Name" />
            )}
            onChange={(event, newInputValue) => {
              let value = newInputValue?.label;
              updateSrfObject("clientId", parseInt(value?.split(",")[0]));
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="place"
            size="small"
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("place", e.target.value);
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="Courier Partner"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("courierPartner", e.target.value);
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="discription"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("discription", e.target.value);
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="purpose"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("purpose", e.target.value);
            }}
          />
        </Grid>{" "}
        <Grid item  xs={12} sm={12} md={3} lg={3}>
          <TextField
            id="outlined-basic"
            label="trackingNo"
            size="small"
            inputProps={{
              autoComplete: 'off',
            }}
            fullWidth
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("trackingNo", e.target.value);
            }}
          />
        </Grid>{" "}
      </Grid>
      <br />

      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={executing}
          variant="contained"
          size="small"
          sx={{ m: 0 }}
          onClick={() => {
            if (!srfObject.clientId) {
              toast.error('Please select a client');
              return;
            }
            if (!srfObject.date) {
              toast.error('Please select a date');
              return;
            }
            onSubmit();
          }}
        >
          Save
        </Button>
      </Toolbar>
      <ToastContainer />
    </Paper>
  );
}
